import { Description, SocialAvatar, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { getUsernameHandle } from 'utils/social-platforms';
import { useSocialSharePlatform } from '../SocialSharePlatforms';
import { SocialShareAccount } from '../types';
import { socialShareModalAccountSelectBlock as block } from '../utils';

export type SocialUserDetailsProps = Partial<
  Pick<SocialShareAccount, 'username' | 'handle' | 'avatarSrc'>
> & {
  className?: string;
};

const SocialUserDetails: React.FC<SocialUserDetailsProps> = ({
  username,
  handle,
  avatarSrc,
  className,
}) => {
  const { platformAlias } = useSocialSharePlatform();

  return (
    <Spacer
      orientation="horizontal"
      space="15px"
      align="center"
      justify="center"
      className={className}
    >
      {avatarSrc && <SocialAvatar src={avatarSrc} platform={platformAlias} />}

      <Description>
        <Description.Headline className={block('social-user-details-headline')}>
          <Description.Headline.SecondaryText>
            {username}
          </Description.Headline.SecondaryText>

          <Description.Headline.SecondaryText size="12px" weight={400}>
            {getUsernameHandle(handle)}
          </Description.Headline.SecondaryText>
        </Description.Headline>
      </Description>
    </Spacer>
  );
};

export default SocialUserDetails;
